// 下单区类型
export enum SwitchOrderTypeProps {
  ct = "ct", // 合约下单
  strategy = "strategy", // 策略下单
}

/**
 * hasValue
 */
export const HAS_VALUE = "hasValue";

// 来源类型
export enum SourceTypeProps {
  Contract = "ct", // 合约
  Spot = "spot", // 现货
}

// 公告信息业务线枚举
export enum NotificationBizTypeEnum {
  FUTURES = 2, // 合约
  SPOT = 3, // 现货
  FUTURES_SINGLE = 5, // 合约单条通知
  SPOT_SINGLE = 4, // 现货单条通知
}

// 公告信息对应业务线下的板块ID 板块ID对接人: @Grech Guo
// TODO: 换成线上的对应ID - 已完成
export enum NotificationTabTypeEnum {
  // 现货 - 新币上新板块
  SPOT_NEW_COIN = "5955813039257",
  // 现货 - 产品更新
  SPOT_PRODUCT_UPDATE = "12508313445209",
  // 现货 - 近期活动板块
  SPOT_EVENT = "4413154768537",
  // 现货 - 维护/升级板块
  SPOT_UPGRADE = "12508313404850",

  // 合约 - 新币上新板块
  FUTURES_NEW_COIN = "12508313405000",
  // 合约 - 产品更新
  FUTURES_PRODUCT_UPDATE = "12508313445234",
  // 合约 - 近期活动板块
  FUTURES_EVENT = "4413154768537",
  // 合约 - 维护/升级板块
  FUTURES_UPGRADE = "12508313404950",
}

// 止盈止损的设置类型定义
export enum TPSLTYPE {
  TYPE_A_PRICE = 0, // 默认价格 下单区特殊处理了
  TYPE_A_RATE_RETURN = 1, // 默认收益率
  TYPE_B_QUOTE_CHANGE = 2, // 涨跌幅
  TYPE_C_PROFIT_LOSS = 3, // 盈亏
}
